module.exports = __webpack_public_path__ + "img/left_right_layout_2_outline.2877593d.jpg";